// var preOrderId = null;
export default {
    name: 'constant',
    BASE_URL: "//groupbuybe.payboard.in/saleService/",
    BANNER_URL: "//groupbuybe.payboard.in/bannerService/",
    SOCIAL_URL: "//groupbuybe.payboard.in/saleSocialService/",
    CATALOGUE_URL: "//groupbuybe.payboard.in/catalogueService/",
    ADDRESS_URL: "//groupbuybe.payboard.in/api/v1/users/",
    COUNTRY_URL: "//groupbuybe.payboard.in/catalogueService/",
    ORDER_URL: "//groupbuybe.payboard.in/orderService/",
    ORDER_RETURN_URL: "//groupbuybe.payboard.in/returnService/",
    BASE_URL_ORDERS_PAYMENT: "//groupbuybe.payboard.in/api/v1/payment-service/doPay/",
    LOGIN_URL: "//be.payboard.in/PayBoard/rest/webapp/",
    USER_PROFILE_URL: "//groupbuybe.payboard.in/api/v1/users/account-info",
    SEARCH_URL: "//groupbuybe.payboard.in/api/v1/searchService/",
    PAYBOARD_URL: "//be.payboard.in/PayBoard/rest/",
    AI_URL: window.location.hostname === 'localhost' ? 'http://localhost:5000/' : "https://aibe.mall91.com/",
    GROUP_API_URL: "https://776c3ae5.ngrok.io/groupShoppingService/fetchGroupByProductId",
    GET_GROUP_API: "//groupbuybe.payboard.in/groupShoppingService/",
    SCRATCH_API_URL: "//scratchcard.mall91.com/rewardService/",
    GETTEXT: {
        "CANCELLED_BY_SELLER": "Cancelled by seller",
        "CANCELLED_BY_USER": "Cancelled",
        "CONFIRMED": "Confirmed",
        "CUSTOMER_CONFIRMED": "Confirmed",
        "PAYMENT_SUCCESSFUL": "Confirmed",
        "GROUP_PURCHASE_ORDER_PLACED": "Placed",
        "IN_INVENTORY": "Placed",
        "ORDER_DELIVERED": "Delivered",
        "ORDER_DISPATCHED": "Dispatched",
        "ORDER_PLACED_TO_SUPPLIER": "Placed to supplier",
        "ORDER_RECEIVED_FROM_SUPPLIER": "Packed",
        "ORDER_READY_TO_DISPATCH": "Shipment Ready",
        "PAYMENT_CANCELLED": "Payment pending",
        "PAYMENT_FAILURE": "Payment pending",
        "PAYMENT_PENDING": "Payment pending",
        "CO_PENDING": "Order not confirm",
        "RETURN_BY_USER": "Return accepted",
        "GROUP_PURCHASE_ORDER_CANCELLED": "Cancelled"
    },
    getReturnText: {
        "INITIATED": "Return Request",
        "SCHEDULED": "Pickup scheduled",
        "DTO": "item reached at warehouse",
        "RETURN_COMPLETED": "Your payment refunded",
        "CANCELED": "Canceled"
    },
    getAPIMessages: {
        "Success": "Operation successfully performed!",
        "Failure": "Something went wrong!",
        "Warning": "Warning!",
        "orderAgain": "Something went wrong! Order again",
        "placedOrder": "कृपया जारी रखने के लिए सभी फ़ील्ड ठीक से भरें !",
        "validMobileNo": "कृपया मान्य मोबाइल नंबर दर्ज करें !",
        "validPincode": "कृपया मान्य पिन कोड दर्ज करें !",
        "ItemOutStock": "Item is out of stock",
        "JSBridgePluginError": "Can't open Profile",
        "CommentInputError": "Please write comment first !",
        "SelectOneOption": "चुनिन्दा ऑप्शन सेलेक्ट करे"
    },
    getToasterColours: {
        "Success": "Green",
        "Failure": "Red",
        "Warning": "Orange",
        "orderAgain": "Red",
        "placedOrder": "Red",
        "validMobileNo": "Red",
        "validPincode": "Red",
        "ItemOutStock": "Red",
        "JSBridgePluginError": "Red",
        "CommentInputError": "Red",
        "SelectOneOption": "Red"
    },
    hideHeaderComponents: [
        'VideoDetailsPage',
        'LiveSchedulePage',
        'detail',
        'merchandiseProduct',
        'ProductsListingByCategory',
        'ShippingDetails',
        'PreOrderDetails',
        'PaymentWaiting',
        'ProductReturn',
        'GroupList',
        'NearPayOrderDetails',
        'GroupsProductListing',
        'CutThePriceProductListing',

    ],
    showAIComponents: [
        'home'
    ],
    ShowHeaderComponents: [
        'home'
    ],
    ShowDetailHeaderComponents: [
        'ShoppingGame',
        'OrderHistory',
        'LiveShowList',
        'CategoryListing'
    ],
    ShowFooterComponents: [
        'home',
        'ShoppingGame',
        'OrderHistory',
        'OrderHistoryNew',
        'TvShop',
        'LiveShowList',
        'CategoryListing'
    ],
    hideBackHeaderComponents: [
        'ShoppingGame',
        'OrderHistory',
        'TvShop',
        'home',
        'ProductDetail',
        'LiveShowList',
        'CategoryListing',
        'GroupList',
        'VideoDetailsPage',
        'LiveShow',
        'OrderHistoryNew',
        'ProductComment',
        'ProductListing',
        'ProductDetail',
        'ShippingDetails',
        'CancelOrder'
    ],


    adminXAuthIds: [

        "1ee2e5e34c2886bf91b82adfcea38b4c",
        'da4fb5c6e93e74d3df8527599fa62642',
        '8f14e45fceea167a5a36dedd4bea2543'

    ],
    preOrderDetailsText: `आपका प्री ऑर्डर है: `,
    orderConfirmationText: `आर्डर प्लेस करने के लिए हमारे कॉल ऑपरेटर को अपनी प्री ऑर्डर ID `,
    CountryState: [
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Chandigarh",
        "Dadra and Nagar Haveli",
        "Daman and Diu",
        "Delhi",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jammu and Kashmir",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Orissa",
        "Punjab",
        "Pondicherry",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal"
    ]
}
